import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface ChainStatusData {
  message: string;
  data: {
    status: string;
  };
}

export function useObjectChainStatus(uuid: string, container: string) {
  const { keycloak } = useKeycloak();

  return useQuery(['object-chain', uuid, container], {
    enabled: !!uuid && !!container,
    queryFn: async (): Promise<ChainStatusData> => {
      const body = {
        uuid: uuid,
        container: container,
      };

      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/query_bundle/functions/get_object_chain_status`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(body),
        }
      );

      return response.json();
    },
    refetchInterval: 5000,
  });
}
